import ChangeEmergencyContactModalComponent from './change-emergency-contact.component'

const ChangeEmergencyContactDialogModule = angular.module('cdbl.account-change-emergency-contact', [

])
  .component('cdblAccountChangeEmergencyContact', ChangeEmergencyContactModalComponent)
  .name

export default ChangeEmergencyContactDialogModule
